// Generated code for Big.Entities.Land.
// Edit _Enum.tst to change the generated output.

export enum Land {
    onbekend = 0,
    canada = 5001,
    frankrijk = 5002,
    zwitserland = 5003,
    rhodesie = 5004,
    malawi = 5005,
    cuba = 5006,
    suriname = 5007,
    tunesie = 5008,
    oostenrijk = 5009,
    belgie = 5010,
    botswana = 5011,
    iran = 5012,
    nieuwZeeland = 5013,
    zuidAfrika = 5014,
    denemarken = 5015,
    noordJemen = 5016,
    hongarije = 5017,
    saoediArabië = 5018,
    liberia = 5019,
    ethiopië = 5020,
    chili = 5021,
    marokko = 5022,
    togo = 5023,
    ghana = 5024,
    laos = 5025,
    angola = 5026,
    filipijnen = 5027,
    zambia = 5028,
    mali = 5029,
    ivoorkust = 5030,
    burma = 5031,
    monaco = 5032,
    colombia = 5033,
    albanie = 5034,
    kameroen = 5035,
    zuidVietnam = 5036,
    singapore = 5037,
    paraguay = 5038,
    zweden = 5039,
    cyprus = 5040,
    australischNieuwGuinea = 5041,
    brunei = 5042,
    irak = 5043,
    mauritius = 5044,
    vaticaanstad = 5045,
    kashmir = 5046,
    myanmar = 5047,
    jemen = 5048,
    slovenie = 5049,
    zaire = 5050,
    kroatie = 5051,
    taiwan = 5052,
    rusland = 5053,
    armenie = 5054,
    ascension = 5055,
    azoren = 5056,
    bahrein = 5057,
    bhutan = 5058,
    britseAntillen = 5059,
    comoren = 5060,
    falklandeilanden = 5061,
    fransGuyana = 5062,
    fransSomaliland = 5063,
    gilbertEnElliceEilanden = 5064,
    groenland = 5065,
    guadeloupe = 5066,
    kaapverdischeEilanden = 5067,
    macau = 5068,
    martinique = 5069,
    mozambique = 5070,
    pitcairneilanden = 5071,
    guineeBissau = 5072,
    reunion = 5073,
    saintPierreEnMiquelon = 5074,
    seychellenEnAmiranten = 5075,
    tonga = 5076,
    wallisEnFutuna = 5077,
    zuidwestAfrika = 5078,
    fransIndië = 5079,
    johnston = 5080,
    kedah = 5081,
    kelantan = 5082,
    malakka = 5083,
    mayotte = 5084,
    negriSembilan = 5085,
    pahang = 5086,
    perak = 5087,
    perlis = 5088,
    portugeesIndië = 5089,
    selangor = 5090,
    sikkim = 5091,
    saintVincentendeGrenadines = 5092,
    spitsbergen = 5093,
    trengganu = 5094,
    aruba = 5095,
    burkinaFaso = 5096,
    azerbeidzjan = 5097,
    belarus = 5098,
    kazachstan = 5099,
    macedonie = 5100,
    timorLeste = 5101,
    servieEnMontenegro = 5102,
    servie = 5103,
    montenegro = 5104,
    kosovo = 5105,
    bonaire = 5106,
    curacao = 5107,
    saba = 5108,
    sintEustatius = 5109,
    sintMaarten = 5110,
    moldavie = 6000,
    burundi = 6001,
    finland = 6002,
    griekenland = 6003,
    guatemala = 6004,
    nigeria = 6005,
    libie = 6006,
    ierland = 6007,
    brazilie = 6008,
    rwanda = 6009,
    venezuela = 6010,
    ijsland = 6011,
    liechtenstein = 6012,
    somalië = 6013,
    verenigdeStatenVanAmerika = 6014,
    bolivia = 6015,
    australie = 6016,
    jamaica = 6017,
    luxemburg = 6018,
    tsjaad = 6019,
    mauritanie = 6020,
    kirgizië = 6021,
    china = 6022,
    afghanistan = 6023,
    indonesie = 6024,
    guyana = 6025,
    noordVietnam = 6026,
    noorwegen = 6027,
    sanMarino = 6028,
    duitsland = 6029,
    nederland = 6030,
    cambodja = 6031,
    fiji = 6032,
    bahamas = 6033,
    israel = 6034,
    nepal = 6035,
    zuidKorea = 6036,
    spanje = 6037,
    oekraïne = 6038,
    grootBrittanië = 6039,
    niger = 6040,
    haiti = 6041,
    jordanie = 6042,
    turkije = 6043,
    trinidadEnTobago = 6044,
    joegoslavie = 6045,
    opperVolta = 6046,
    algerije = 6047,
    gabon = 6048,
    noordKorea = 6049,
    oezbekistan = 6050,
    sierraLeone = 6051,
    britsHonduras = 6052,
    canarischeEilanden = 6053,
    fransPolynesië = 6054,
    gibraltar = 6055,
    portugeesTimor = 6056,
    tadzjikistan = 6057,
    britseSalomonseilanden = 6058,
    saoTomeEnPrincipe = 6059,
    sintHelena = 6060,
    tristanDaCunha = 6061,
    westSamoa = 6062,
    turkmenistan = 6063,
    georgie = 6064,
    bosnieHerzegovina = 6065,
    tsjechie = 6066,
    slowakije = 6067,
    federaleRepubliekJoegoslavie = 6068,
    democratischeRepubliekCongo = 6069,
    uganda = 7001,
    kenya = 7002,
    malta = 7003,
    barbados = 7004,
    andorra = 7005,
    mexico = 7006,
    costaRica = 7007,
    gambia = 7008,
    syrie = 7009,
    nederlandseAntillen = 7011,
    zuidJemen = 7012,
    egypte = 7014,
    argentinie = 7015,
    lesotho = 7016,
    honduras = 7017,
    nicaragua = 7018,
    pakistan = 7020,
    senegal = 7021,
    dahomey = 7023,
    bulgarije = 7024,
    maleisie = 7026,
    dominicaanseRepubliek = 7027,
    polen = 7028,
    ruslandOud = 7029,
    britseMaagdeneilanden = 7030,
    tanzania = 7031,
    elSalvador = 7032,
    sriLanka = 7033,
    soedan = 7034,
    japan = 7035,
    hongkong = 7036,
    panama = 7037,
    uruguay = 7038,
    ecuador = 7039,
    guinee = 7040,
    maldiven = 7041,
    thailand = 7042,
    libanon = 7043,
    italie = 7044,
    koeweit = 7045,
    india = 7046,
    roemenie = 7047,
    tsjechoSlowakije = 7048,
    peru = 7049,
    portugal = 7050,
    oman = 7051,
    mongolie = 7052,
    samoa = 7053,
    verenigdeArabischeEmiraten = 7054,
    tibet = 7055,
    nauru = 7057,
    nederlandsNieuwGuinea = 7058,
    tanganyika = 7059,
    palestina = 7060,
    britsWestIndië = 7062,
    portugeesAfrika = 7063,
    letland = 7064,
    estland = 7065,
    litouwen = 7066,
    britsAfrika = 7067,
    belgischCongo = 7068,
    britsIndië = 7070,
    noordRhodesië = 7071,
    zuidRhodesië = 7072,
    saarland = 7073,
    fransIndochina = 7074,
    britsWestBorneo = 7075,
    goudkust = 7076,
    rasalKhaimah = 7077,
    fransCongo = 7079,
    siam = 7080,
    britsOostAfrika = 7082,
    britsNoordBorneo = 7083,
    bangladesh = 7084,
    duitseDemocratischeRepubliek = 7085,
    madeiraEilanden = 7087,
    amerikaanseMaagdeneilanden = 7088,
    australischeSalomonseilanden = 7089,
    spaanseSahara = 7091,
    caymaneilanden = 7092,
    caicoseilanden = 7093,
    turkseilanden = 7094,
    britsAntarctischTerritorium = 7095,
    britsIndischeOceaanterritorium = 7096,
    cookeilanden = 7097,
    tokelau = 7098,
    nieuwCaledonië = 7099,
    hawaiiEilanden = 8000,
    guam = 8001,
    amerikaansSamoa = 8002,
    midway = 8003,
    riukiueilanden = 8004,
    wake = 8005,
    pacificeilanden = 8006,
    grenada = 8008,
    marianen = 8009,
    cabinda = 8010,
    cantonEnEnderbury = 8011,
    christmaseiland = 8012,
    cocoseilanden = 8013,
    faeroer = 8014,
    montserrat = 8015,
    norfolk = 8016,
    belize = 8017,
    tasmanie = 8018,
    turksEnCaicoseilanden = 8019,
    puertoRico = 8020,
    papoeaNieuwGuinea = 8021,
    salomonseilanden = 8022,
    benin = 8023,
    vietnam = 8024,
    kaapverdie = 8025,
    seychellen = 8026,
    kiribati = 8027,
    tuvalu = 8028,
    saintLucia = 8029,
    dominica = 8030,
    zimbabwe = 8031,
    dubai = 8032,
    nieuweHebriden = 8033,
    kanaaleilanden = 8034,
    man = 8035,
    anguilla = 8036,
    saintKittsenNevis = 8037,
    antigua = 8038,
    saintVincent = 8039,
    gilberteilanden = 8040,
    panamakanaalzone = 8041,
    saintKitts = 8042,
    nevisenAnguilla = 8042,
    belau = 8043,
    palau = 8044,
    antiguaEnBarbuda = 8045,
    newfoundland = 9000,
    nyasaland = 9001,
    eritrea = 9003,
    ifni = 9005,
    britsKameroen = 9006,
    keizerWilhelmsland = 9007,
    congo = 9008,
    congoKinshasa = 9009,
    madagaskar = 9010,
    congoBrazzaville = 9013,
    leeuwardeilanden = 9014,
    winwardeilanden = 9015,
    fransTerritoriumvoorAfarsenIssas = 9016,
    phoenixeilanden = 9017,
    portugees = 9020,
    duitsZuidwestAfrika = 9022,
    namibie = 9023,
    britsSomaliland = 9027,
    italiaansSomaliland = 9028,
    nederlandsIndië = 9030,
    britsGuyana = 9031,
    swaziland = 9036,
    qatar = 9037,
    aden = 9041,
    zuidArabischeFederatie = 9042,
    equatoriaalGuinea = 9043,
    spaansGuinee = 9044,
    verenigdeArabischeRepubliek = 9047,
    bermuda = 9048,
    sovjetUnie = 9049,
    duitsOostAfrika = 9050,
    zanzibar = 9051,
    ceylon = 9052,
    muscatEnOman = 9053,
    trucialOman = 9054,
    indochina = 9055,
    marshalleilanden = 9056,
    sarawak = 9057,
    britsBorneo = 9058,
    sabah = 9060,
    abuDhabi = 9061,
    ajman = 9062,
    basutoland = 9063,
    bechuanaland = 9064,
    fujairah = 9065,
    fransKameroen = 9066,
    johore = 9067,
    korea = 9068,
    labuan = 9069,
    ummAlQaiwan = 9070,
    oostenrijkHongarije = 9071,
    portugeesOostAfrika = 9072,
    portugeesWestAfrika = 9073,
    sharjah = 9074,
    straitsSettlements = 9075,
    abessinie = 9076,
    fransWestAfrika = 9077,
    fransEquatoriaalAfrika = 9078,
    urundi = 9081,
    ruandaUrundi = 9082,
    goa = 9084,
    dantzig = 9085,
    centraalAfrikaanseRepubliek = 9086,
    djibouti = 9087,
    transjordanie = 9088,
    bondsrepubliekDuitsland = 9089,
    vanuatu = 9090,
    niue = 9091,
    spaansNoordAfrika = 9092,
    westelijkeSahara = 9093,
    micronesia = 9094,
    svalbardeilanden = 9095,
    witRuslandBelarus = 9096,
    internationaalGebied = 9999
}
(Land as any).name = 'Land';
